import { CountUp } from 'countup.js';

let countUpId = 1;
let contCountUpId = 1;

/**
 * Init CountUp (default behaviour, supports ajax)
 */
window.initCountUp = function initCountUp(container = document) {
  const counts = Array.from(
      container.querySelectorAll('.count-up:not(.is-count-init)')
  );

  if (!counts.length) return;

  const defaultOptions = {
    separator: '.',
    enableScrollSpy: true,
    scrollSpyRunOnce: true,
  };

  counts.forEach((count) => {
    count.classList.add('is-count-init');

    const value = parseFloat(count.textContent.replace(',', '.'));
    if (isNaN(value)) return;

    const id = `count-up-${countUpId++}`;
    count.id = id;

    const optionsFromDataAttr = { ...count.dataset };

    for (const key in optionsFromDataAttr) {
      if (optionsFromDataAttr[key] === '') {
        optionsFromDataAttr[key] = true;
      }
    }

    const decimalPlaces =
        (count.textContent.split('.')[1]?.length) || 0;

    count._countUpInstance = new CountUp(
        id,
        value,
        Object.assign(
            {},
            defaultOptions,
            optionsFromDataAttr,
            { decimalPlaces }
        )
    );
  });
};

/**
 * Force restart animation
 */
window.restartCountUp = function restartCountUp(container = document) {
  const counts = Array.from(
      container.querySelectorAll('.count-up.is-count-init')
  );

  if (!counts.length) return;

  counts.forEach((count) => {
    const instance = count._countUpInstance;
    if (!instance) return;

    instance.reset();
    instance.start();
  });
};

/**
 * Container-based observer
 * запускает ВСЕ count-up внутри контейнера
 */
window.initContainerCountUp = function initContainerCountUp({
                                                              container,
                                                              root = null,
                                                              rootMargin = '0px',
                                                              threshold = 0.3,
                                                              runOnce = true,
                                                            }) {
  const containerEl =
      typeof container === 'string'
          ? document.querySelector(container)
          : container;

  if (!containerEl) return;

  if (containerEl._contCountUpObserverInit) return;
  containerEl._contCountUpObserverInit = true;

  const runCountUp = () => {
    const items = Array.from(
        containerEl.querySelectorAll(
            '.cont-count-up:not(.is-cont-count-init)'
        )
    );

    if (!items.length) return;

    items.forEach((item) => {
      item.classList.add('is-cont-count-init');

      const value = parseFloat(item.textContent.replace(',', '.'));
      if (isNaN(value)) return;

      const id = `cont-count-up-${contCountUpId++}`;
      item.id = id;

      const optionsFromDataAttr = { ...item.dataset };

      for (const key in optionsFromDataAttr) {
        if (optionsFromDataAttr[key] === '') {
          optionsFromDataAttr[key] = true;
        }
      }

      const decimalPlaces =
          (item.textContent.split('.')[1]?.length) || 0;

      item._contCountUpInstance = new CountUp(
          id,
          value,
          Object.assign(
              {},
              optionsFromDataAttr,
              { decimalPlaces }
          )
      );

      item._contCountUpInstance.start();
    });
  };

  const rect = containerEl.getBoundingClientRect();
  const isVisible =
      rect.top < window.innerHeight &&
      rect.bottom > 0;

  if (isVisible) {
    runCountUp();
    return;
  }

  const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;

          runCountUp();

          if (runOnce) {
            observer.unobserve(containerEl);
          }
        });
      },
      { root, rootMargin, threshold }
  );

  observer.observe(containerEl);
};

initCountUp();
